import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Link } from 'react-router-dom';
import draftToHtml from 'draftjs-to-html';
import { Image, StepsToGetQuote, WithTitle, Slider, TipsTrendsItem, Search, PopularProducts } from '../components';
import { withRedux } from '../hoc';
import { getServiceUrl } from '../utils';

const TIPSTRENDS_ID = _.toInteger(process.env.REACT_APP_TIPSTRENDS_ID);

const PrevArrow = props => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      {'< BACK'}
    </div>
  );
};

const NextArrow = props => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      {'NEXT >'}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    post: _.get(state, 'post')
  };
};

const actions = {};

@withRedux(mapStateToProps, actions)
export default class TipsTrendsDetail extends Component {
  render() {
    const { t } = this.props;
    const id = _.get(this.props, 'match.params.id');
    const posts = _.get(this.props, 'post.posts.data');
    const tipstrend = _.get(this.props, `post.posts.data.${id}`);
    const tipstrend_image_full_file_path = `${getServiceUrl()}/${_.get(tipstrend, 'image.path')}`;
    const title = t(_.get(tipstrend, 'title'));
    let tipstrends = _.filter(posts, post => post.post_category_id === TIPSTRENDS_ID);
    tipstrends = _.orderBy(tipstrends, ['created_at', 'updated_at'], ['desc', 'desc']);
    let rows = 2;
    const slidesToShow = 4;
    if (_.size(tipstrends) < rows * slidesToShow) {
      rows = 1;
    }
    return (
      <div className="tipstrends-detail-page container-wrapper">
        <div className="search-block">
          <Search.Main />
        </div>
        <div className="main-topic">
          <div className="container">
            <ul className="breadcrumb">
              <li>
                <Link to="/tips-trends">{t('Tips & Trends')}</Link>
              </li>
              <li>
                <span>></span>
              </li>
              <li>
                <span>{title}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="main-content clearfix">
          <div className="container">
            <div className="title">{title}</div>
            <div className="descriptions">
              <div className="image">
                <Image src={tipstrend_image_full_file_path} alt={title} />
              </div>
              <div
                className="wysiwyg"
                dangerouslySetInnerHTML={{
                  __html: draftToHtml(t(_.get(tipstrend, 'description')))
                }}
              />
            </div>
          </div>
        </div>
        <div className="other-tips">
          <div className="container">
            <div className="with-title-with-slide">
              <WithTitle title={t('Other Tips')} backgroundColor="#d0021b">
                <Slider
                  className="arrow-type-text"
                  items={tipstrends}
                  uiRenderer={data => {
                    const date = moment(data.created_at).format('MMM D YYYY');
                    const image_full_file_path = `${getServiceUrl()}/${_.get(data, 'image.path')}`;
                    return (
                      <Link to={`/tips-trends/detail/${_.get(data, 'id')}`}>
                        <TipsTrendsItem.Grid image={image_full_file_path} date={date} title={t(_.get(data, 'title'))} />
                      </Link>
                    );
                  }}
                  settings={{
                    rows,
                    slidesToShow,
                    slidesToScroll: slidesToShow,
                    prevArrow: <PrevArrow />,
                    nextArrow: <NextArrow />
                  }}
                />
              </WithTitle>
            </div>
          </div>
        </div>
        <div className="popular-products-block">
          <div className="container">
            <PopularProducts />
          </div>
        </div>
        <div className="steps-quote-block">
          <StepsToGetQuote />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/TipsTrendsDetail.js